module.exports = __webpack_public_path__ + "src/assets/2019/10.jpg";